import { Button, Checkbox, Divider, Flex } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Heading2 } from 'components/Heading2';
import { Modal } from 'components/Modal';
import { TextS } from 'components/Text';
import theme from 'theme/theme';
import { signMethodOptions } from '../TemplateConfig';
import { Body } from './styles';
import { AccountType } from 'types/Account';
const CheckboxGroup = Checkbox.Group;

interface ISignerMethodModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSave: (type: AccountType) => void;
	options: string[];
	setOptions: (list: string[]) => void;
	type: AccountType;
}

const SignerMethodModal = ({
	options,
	isOpen,
	onClose,
	onSave,
	setOptions,
	type,
}: ISignerMethodModalProps) => {
	const escrow = type === AccountType.ESCROW;
	const onChange = (list: string[]) => {
		setOptions(list);
	};

	return (
		<Modal
			isOpen={isOpen}
			title="Configurações da conta"
			width={500}
			height={300}
			onClose={onClose}
			style={{
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<Body>
				<Heading2>
					Método de assinatura:{' '}
					{escrow ? 'Conta Escrow' : 'Conta Livre'}
				</Heading2>
				<CheckboxGroup
					options={signMethodOptions}
					value={options}
					onChange={onChange}
				/>

				<Flex vertical>
					<Button
						onClick={() => onSave(type)}
						type="primary"
						style={{ marginTop: '2rem', padding: '1rem' }}
					>
						<TextS color={theme.white}>Salvar alterações</TextS>
					</Button>
					<Button
						onClick={onClose}
						type="text"
						style={{ marginTop: '1rem' }}
					>
						<TextS color={theme.primary}>Cancelar</TextS>
					</Button>
				</Flex>
			</Body>
		</Modal>
	);
};

export default SignerMethodModal;
